<template>
    <md-modal :open="open" :showFooter="true">

        <template v-slot:title>
            {{ __('labels.basics.mail') }}
        </template>
        <template v-slot:content>
            <div v-if="possibleDocuments.length > 0">
                <SelectInput :options="possibleDocuments" v-model:value="selected_document">
                </SelectInput>
            </div>
            <div v-if="documentData && documentData.is_sent && documentData.mails.status">
                <div class="flex flex-row justify-between mt-2">
                    <div class="">
                        <i class="fas fa-exclamation"></i>
                    </div>
                    <div class="justify-end">
                        <translation :ident="'labels.basics.' + documentData.mails.status"></translation> <translation ident="labels.basics.at"></translation>
                    </div>
                    <div>
                        {{ __datetime(documentData.mails.sent_at ?? documentData.mails.outgoing_at) }}
                    </div>
                </div>
            </div>
            <div class="w-full" style="height:200px">
                <div class="flex flex-col my-5">
                    <dropdown-search-menu v-if="!none_selected" :options="{
                        placeholder: 'Select Template',
                        inputIcon: 'fas fa-coins',
                        title_clear: 'Clear',
                    }" :keys="$store.state.companies.infinity.columns" :selectkeys="['name']"
                        v-model:search="this.search" :selected="this.templateId" :values="templates"
                        :is-loading="template_loading"
                        @dropdown:select="search = $event.name; templateId = $event.id; getRecipients();"
                        @update:search="searchTemplates($event)">
                        <template v-slot:label>{{ __('labels.emailtemplates.title') }}</template>
                    </dropdown-search-menu>
                </div>

                <div class="flex flex-col my-5">
                    <label class="text-base text-stone-900 dark:text-slate-100 font-bold block">
                        <translation ident="labels.email.recipients"></translation>
                    </label>
                    <div class="justify-center px-2 flex flex-col">
                        <SimpleLoadingIcon v-if="infos.loading"></SimpleLoadingIcon>
                        <ul cn="email_recipients" class="list-decimal list-inside" v-if="infos.recipients.length > 0">
                            <li class="hover:bg-gray-200" v-for="recipient in infos.recipients" :key="recipient.email">
                                {{ recipient.last_name }}, {{ recipient.first_name }} {{ recipient.email }}
                            </li>
                        </ul>
                        <div v-else>
                        </div>
                    </div>
                </div>


                <div class="flex flex-col mb-6" v-if="isError">
                    <custom-alert predefinedStyle="error">
                        <template v-slot:icon><i class="fas fa-exclamation-circle"
                                style="font-size:1.3rem"></i></template>
                        <template v-slot:label>
                            <p class="font-bold">{{ __('labels.error.default') }}</p>
                        </template>
                        <template v-slot:content>
                            <div class="text-sm" v-if="errors != null && errorMessages.length > 0">
                                <ul v-html="errorMessages"></ul>
                            </div>
                        </template>
                    </custom-alert>
                </div>



                <div class="flex flex-col mb-6" v-if="isSuccess">
                    <custom-alert predefinedStyle="success">
                        <template v-slot:icon><i class="fas fa-exclamation-circle"
                                style="font-size:1.3rem"></i></template>
                        <template v-slot:label>
                            <p class="font-bold">{{ __('labels.email.prepare_success') }}</p>
                        </template>
                        <template v-slot:content>
                        </template>
                    </custom-alert>
                </div>

            </div>
        </template>
        <template v-slot:footer>
            <div class="flex flex-row justify-between">
                <div class="text-right">
                    <custom-button predefinedStyle="transparent" @click="$emit('close')">
                        <template v-slot:label>
                            {{ __('labels.basics.close') }}
                        </template>
                    </custom-button>
                </div>
            </div>

            <custom-button predefinedStyle="default" @button:click="save($event, true)" :loading="isSaving"
                :disabled="isSaving || none_selected || templateId == 0" css="ml-4">
                <template v-slot:label>
                    {{ __('labels.basics.send_show') }}
                </template>
            </custom-button>

        </template>
    </md-modal>
</template>
<script>
import mdModal from '../basicmodal/md-modal.vue';
import SimpleLoadingIcon from '../basics/SimpleLoadingIcon.vue';
export default {
    components: {
        mdModal,
        SimpleLoadingIcon
    },
    props: {
        open: {},
        document: {},
        documentType: {},
    },
    data() {
        return {
            search: null,
            templateId: 0,
            isError: false,
            errors: null,
            isSaving: false,
            isSuccess: false,
            selected_document: 0,
            infos: {
                recipients: [],
                loading: false,
                debounce: null,
            },
            debounce: {
                template: null,
            },
        };
    },
    created() {
        if (this.templates[0] != undefined) {
            this.templateId = this.templates[0].id;
            this.search = this.templates[0].name;
        }
    },
    mounted() {

    },
    computed: {
        documentData() {
            let document = null;
            if (this.document.length > 1) {
                document = this.document.find(data => data.id == this.selected_document);
            } else {
                document = this.document[0];
            }
            return document;
        },
        possibleDocuments() {
            let tmp = [];
            if (this.document && this.document.length > 1) {
                for (let i in this.document) {
                    tmp.push({
                        value: this.document[i].id,
                        name: this.document[i].name,
                        disabled: false,
                    });
                }
            }
            return tmp;
        },
        none_selected() {
            if ((this.document.length > 1 && this.selected_document == 0 )) {
                return true;
            }
            return false;
        },
        lodash() {
            return _;
        },

        errorMessages() {
            var tmp = "";
            if (this.errors !== null) {
                var keys = Object.keys(this.errors);
                for (let i = 0; i < keys.length; i++) {
                    tmp += "<li>" + this.errors[keys[i]] + "</li>";
                }
            }
            return tmp;
        },
        filtering() {
            return {
                OOI: ["c", "inv", "offer", "d_po"],
                purchase: ["po"],
            };
        },
        recipient_path() {
            if (this.templateFilter == "purchase") {
                return "data.supplier.id";
            }
            return "data.company.id";
        },
        real_type() {
            if (this.selected_document) {
                let index = this.document.findIndex(data => data.id == this.selected_document);
                if (this.document[index].type == "po") {
                    return "purchase_contract";
                }
            }
            return this.documentType;
        },
        templateFilter() {
            if (this.document) {
                for (let i in this.filtering) {
                    if (this.document.length > 1 && this.selected_document) {
                        let index = this.document.findIndex(data => data.id == this.selected_document);
                        if (this.filtering[i].includes(this.document[index].type)) {
                            return i;
                        }
                    } else {
                        if (this.filtering[i].includes(this.document[0].type)) {
                            return i;
                        }
                    }
                }

            }
            return "OOI";
        },
        templates() {
            var templates = this.$store.state.emailTemplates.list;
            if (this.templateFilter !== undefined && this.templateFilter != '') {
                var filteredTemplates = [];
                for (const i in templates) {
                    if (templates[i].filter == this.templateFilter) {
                        filteredTemplates.push(templates[i]);
                    }
                }
                return filteredTemplates;
            }
            return templates;
        },
        template_loading() {
            return this.$store.state.emailTemplates.loading;
        },

    },
    watch: {
        open: {
            handler(newVal){
                if(newVal == false){
                    this.selected_document = 0;
                    this.templateId = null;
                    this.infos.recipients = [];
                    this.infos.loading = false;
                    this.isSuccess = false;
                    this.isError = false;
                }
            }
        },
        document: {
            deep: true,
            handler(newVal) {
                if (newVal && newVal.length == 1) {
                    this.infos.recipients = [];
                    this.infos.loading = false;
                    this.search = "";
                    this.$store.commit("emailTemplates/clean");
                    this.$store.dispatch("emailTemplates/load");
                }
            }
        },
        selected_document: {
            handler(newVal) {
                if (newVal && this.document.length > 1) {
                    this.search = "";
                    this.templateId = 0;
                    this.$store.commit("emailTemplates/clean");
                    this.$store.dispatch("emailTemplates/load");
                    this.infos.recipients = [];
                    this.infos.loading = false;
                }
            }
        },

    },
    methods: {
        searchTemplates(event) {
            if (this.debounce.template) {
                clearTimeout(this.debounce.template);
            }
            this.debounce.template = setTimeout(() => {
                this.$store.commit("emailTemplates/clean");
                this.$store.commit("emailTemplates/setSearch", this.search);
                this.$store.commit("emailTemplates/onlyFilter", this.templateFilter);
                this.$store.dispatch("emailTemplates/load");
            }, 300);
        },
        getDocument() {
            let document = null;
            if (this.document.length > 1) {
                document = this.document.find(data => data.id == this.selected_document);
            } else {
                document = this.document[0];
            }
            return document;
        },
        getRecipients() {
            let document = this.getDocument();
            this.infos.recipients = [];
            if (document !== undefined && this.documentType !== undefined) {
                this.infos.loading = true;
                if (this.infos.debounce) {
                    clearTimeout(this.infos.debounce);
                }
                this.infos.debounce = setTimeout(() => {
                    this.$store.dispatch("kooi/sendValidation", {
                        document: JSON.parse(JSON.stringify(document)),
                        subkey: this.documentType,
                        templateId: this.templateId,
                        showMail: false,
                        send_to_overwrite: _.get(document, this.recipient_path, null)
                    }).then((response) => {
                        this.errors = null;
                        this.isError = false;
                        if (response && response.data && response.data) {
                            this.infos.recipients = response.data.data;
                        }
                        this.infos.loading = false;
                    }).catch((err) => {
                        this.errors = err.response?.data?.errors;
                        this.isError = true;
                        this.infos.loading = false;
                        this.infos.recipients = [];
                    });
                }, 200);

            }
        },
        save(event, showMail = false) {
            let document = this.getDocument();

            if (document !== undefined && this.documentType !== undefined) {
                this.isSaving = true;
                this.$store.dispatch("kooi/sendItem", {
                    document: JSON.parse(JSON.stringify(document)),
                    subkey: this.documentType,
                    templateId: this.templateId,
                    showMail: showMail,
                    send_to_overwrite: _.get(document, this.recipient_path, null)
                }).then((response) => {
                    this.errors = null;
                    this.isError = false;
                    this.isSuccess = true;
                    if (showMail == true) {
                        this.emitter.emit("kooi:mails:show", {
                            document: response
                        });
                        this.isSuccess = false;
                    }
                    this.isSaving = false;
                }).catch((err) => {
                    this.errors = err.response?.data?.errors;
                    this.isError = true;
                    this.isSaving = false;
                });
            }
        },
    },
};
</script>
